import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import ReorderIcon from '@material-ui/icons/Reorder';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import AttributeRow from './AttributeRow';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => ({
  drag: {
    marginTop: -1,
    cursor: 'move',
  },
});

class SortableList extends PureComponent {
  static propTypes = {
    list: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    configFields: PropTypes.object.isRequired,
    // Actions
    editPriorityList: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      list: props.list,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      list: nextProps.list,
    };
  }

  dragHandle = SortableHandle(() => {
    const { classes } = this.props;
    return <ReorderIcon className={classes.drag} />;
  });

  sortableItem = SortableElement(({ value, dataIndex }) => {
    const DragHandle = this.dragHandle;

    return (
      <AttributeRow
        value={value}
        configFields={this.props.configFields}
        index={dataIndex}
        dragIcon={<DragHandle />}
        moveItem={this.onSortEnd}
        list={this.state.list}
        editPriorityList={this.props.editPriorityList}
      />
    );
  });

  sortList = SortableContainer(({ items }) => {
    const SortableItem = this.sortableItem;
    const SortableItems = items.map((value, index) => (
      <SortableItem key={`item-${index}`} index={index} dataIndex={index} value={value} />
    ));

    return <div>{SortableItems}</div>;
  });

  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const list = arrayMove(this.state.list, oldIndex, newIndex);
      this.setState({ list });
      this.props.editPriorityList(list);
    }
  };

  render() {
    const list = this.state.list;
    const SortableListElem = this.sortList;

    return (
      <SortableListElem
        lockToContainerEdges
        items={list}
        onSortEnd={this.onSortEnd}
        useDragHandle
      />
    );
  }
}

export default withStyles(styles)(SortableList);
